import { useQuery, UseQueryResult } from 'react-query';
import { KiloClassAgenda, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseClassAgendaProps {
  date: string;
  coaches?: string[];
  locations?: string[];
  eventTypes?: string[];
}

function useClassAgenda({
  date,
  coaches,
  locations,
  eventTypes,
}: IUseClassAgendaProps): UseQueryResult<{ data: Array<KiloClassAgenda> }> {
  const params: UrlParams = { date };

  if (coaches && coaches.length > 0) {
    params.coaches = coaches.join(',');
  }

  if (locations && locations.length > 0) {
    params.locations = locations.join(',');
  }

  if (eventTypes && eventTypes.length > 0) {
    params.event_types = eventTypes.join(',');
  }

  return useQuery(['classes', 'agenda', date, coaches, eventTypes, locations], () =>
    client.get(`kilo-classes/agenda/?${encodeUrlParams(params)}`),
  );
}

export default useClassAgenda;
